// extracted by mini-css-extract-plugin
export default {"deviceListCardContainer":"device-list-card_deviceListCardContainer__axVQx","deviceName":"device-list-card_deviceName__mRsWH","textTruncate":"device-list-card_textTruncate__A-R6F"};